// src/helpers/google-calendar-html-parse.js

//<br>タグ以外のタグを削除
export function removeHTML(html) {
  if(!html || html.length == 0)
    return null
  return html.replace(/(<br>|<br \/>)/g, '\n')
            .replace(/<("[^"]*"|'[^']*'|[^'">])*>/g,'')
            .replace(/\n/g, '<br>')
            .replace(/(<br>\s*)+/ig,'<br>') //連続する<br>を1つに変換
}


// WEBPACK FOOTER //
// ./src/helpers/google-calendar-html-parse.js